const rename = {
	SEQ: "SEQ.SUFFIX",
	SEQ_TOTAL: "SEQ_TOTAL.SUFFIX",
	ISBN_SEQ: "ISBN_SEQ.SUFFIX",
	ISBN_SEQ_TOTAL: "ISBN_SEQ_TOTAL.SUFFIX",
};

export default rename;
